import * as types from '../constants';
import history from '../history';
import Cookies from 'cookies-js';

export function login(data) {
  return {
    type: types.LOGIN,
    data,
  };
}

export function impersonate(data) {
  return {
    type: types.IMPERSONATE,
    data,
  };
}

export function loginWith2FA(data) {
  return {
    type: types.LOGIN_WITH_2FA,
    data,
  };
}

export function checkToken(data) {
  return {
    type: types.CHECK_TOKEN,
    data,
  };
}

export function refreshAccessToken(data) {
  return {
    type: types.REFRESH_TOKEN,
    data,
  };
}

export function logout(redirect = null) {
  localStorage.removeItem('persist:token');
  localStorage.removeItem('persist:refreshToken');
  Cookies.expire('persist:refreshToken');
  Cookies.expire('persist:token');
  const loginUrl = redirect ? `/login?next=${redirect}` : '/login';
  history.push(loginUrl);

  return {
    type: types.LOGOUT,
  };
}

export function validateEmail(email) {
  return {
    type: types.VALIDATE_EMAIL_ON_REGISTER,
    email,
  };
}

export function register(data) {
  return {
    type: types.REGISTER,
    data,
  };
}

export function validatePassword(password) {
  return {
    type: types.VALIDATE_PASSWORD,
    password,
  };
}

export function resetPassword(data) {
  return {
    type: types.RESET_PASSWORD,
    data,
  };
}

export function confirmPasswordReset(data) {
  return {
    type: types.CONFIRM_PASSWORD_RESET,
    data,
  };
}

export function enable2fa(pin) {
  return {
    type: types.ENABLE_2FA,
    pin,
  };
}

export function load2faQR() {
  return {
    type: types.LOAD_2FA_QR,
  };
}

export function remove2fa() {
  return {
    type: types.REMOVE_2FA,
  };
}
